import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useFetch, useModal, useToast, useResource, usePage } from "@/comn/hooks";
import { SF_REVW_PRCSS, URLS, APIS } from "@/tra/tancis/ptli/ptl/revwprcss/services/PtliRevwPrcssService";

export const PTLI0707002S = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal();
    const toast = useToast();
    const { menuId } = usePage({auth: ["auth_ptli0019"]});
    const location = useLocation();
    const pathParts = location.pathname.split("/");
    const lastPart = pathParts[pathParts.length - 1];
    const isViewMode = lastPart.startsWith("com.review.");
    const revwPrcssId = isViewMode ? lastPart : null;
    const [editable, setEditable] = useState(!isViewMode);

    console.log(revwPrcssId);

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "COM0011" },
            { area: "comnCd", comnCd: "COM0024" },
        ],
    });

    const form = {
        revwPrcss: useForm({
            defaultSchema: SF_REVW_PRCSS,
        }),
    };

    const fetch = {
        saveRevwPrcss: useFetch({
            api: (data) => APIS.saveRevwPrcss(data),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.com.00062",
                    onConfirm: () => navigate(URLS.ptli0707001q),
                    close: false,
                });
            },
            onError: (error: any) =>
                modal.openModal({ content: error.response.data.errorMessage }),
        }),
        updateRevwPrcss: useFetch({
            api: (data, id) => APIS.updateRevwPrcss(data, id),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.com.00062",
                    onConfirm: () => navigate(URLS.ptli0707001q),
                    close: false,
                });
            },
            onError: (error: any) =>
                modal.openModal({ content: error.response.data.errorMessage }),
        }),
        deleteRevwPrcss: useFetch({
            api: (id) => APIS.deleteRevwPrcss(id),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.com.00062",
                    onConfirm: () => navigate(URLS.ptli0707001q),
                    close: false,
                });
            },
            onError: (error: any) =>
                modal.openModal({ content: error.response.data.errorMessage }),
        }),
        getRevwPrcss: useFetch({
            api: (id) => APIS.getRevwPrcss(id),
            onSuccess: (data) => {
                const content = data?.revwPrcss?.content;
                if (content) {
                    form.revwPrcss.setValues({
                        usrFdbckPrcssId: content.usrFdbckPrcssId,
                        usrFdbckPrcssNm: content.usrFdbckPrcssNm,
                        bsopClsfCd: content.bsopClsfCd,
                    });
                }
            },
            onError: (error: any) =>
                modal.openModal({ content: error.response.data.errorMessage }),
        }),
    };

    const handler = {
        onSubmitBtnClick: () => {
            form.revwPrcss.handleSubmit(() => {
                modal.openModal({
                    content: "msg.00101",
                    onConfirm: () => {
                        const saveData = form.revwPrcss.getValues();
                        if (isViewMode) {
                            fetch.updateRevwPrcss.fetch(saveData, revwPrcssId);
                        } else {
                            fetch.saveRevwPrcss.fetch(saveData);
                        }
                    },
                });
            })();
        },
        onEditBtnClick: () => setEditable(true),
        onDeleteBtnClick: () => {
            modal.openModal({
                content: "msg.com.00049",
                onConfirm: () => {
                    if (revwPrcssId) {
                        fetch.deleteRevwPrcss.fetch(revwPrcssId);
                    }
                },
            });
        }
    };

    useEffect(() => {
        if (isViewMode && revwPrcssId) {
            fetch.getRevwPrcss.fetch(revwPrcssId);
        } else {
            form.revwPrcss.setFocus("usrFdbckPrcssId");
        }
    }, [isViewMode, revwPrcssId]);

    return (
        <Page>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control
                                    {...form.revwPrcss.schema.usrFdbckPrcssId}
                                    disabled={!editable}
                                />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control
                                    {...form.revwPrcss.schema.usrFdbckPrcssNm}
                                    disabled={!editable}
                                />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control
                                    {...form.revwPrcss.schema.bsopClsfCd}
                                    disabled={!editable}
                                />
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            </form>

            <Layout direction="row">
                <Layout.Left>
                    <Button role="list" onClick={() => navigate(URLS.ptli0707001q)} />
                </Layout.Left>
                <Layout.Right>
                    {isViewMode ? (
                        editable ? (
                            <Button role="save" onClick={handler.onSubmitBtnClick} />
                        ) : (
                            <>
                                <Button role="edit" onClick={handler.onEditBtnClick} />
                                <Button role="delete" onClick={handler.onDeleteBtnClick} />
                            </>
                        )
                    ) : (
                        <Button role="save" onClick={handler.onSubmitBtnClick} />
                    )}
                </Layout.Right>
            </Layout>
        </Page>
    );
};
